import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/site-header";
import { Hero } from "@/components/hero";
import { Categories } from "@/components/categories";
import { FeaturedSpaces } from "@/components/featured-spaces";
import { HowItWorks } from "@/components/how-it-works";
import { ForMerchants } from "@/components/for-merchants";

import { SiteFooter } from "@/components/site-footer";

export const Route = createFileRoute("/")({
  component: Index,
  head: () => ({
    meta: [
      { title: "Spayzo — Book inspiring spaces by the hour" },
      {
        name: "description",
        content:
          "Discover studios, offices, event halls and chalets — bookable by the hour with all the add-ons bundled in. Instant booking, verified hosts.",
      },
      { property: "og:title", content: "Spayzo — Book spaces by the hour, effortlessly" },
      { property: "og:description", content: "Spaces + add-ons in one seamless booking. Studios, offices, event halls, chalets." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://spayzo.lovable.app/" },
      { property: "og:image", content: "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/4b46924f-caa5-4891-9ce1-947b090d8720/id-preview-8ea18073--cf527af3-c9f5-472e-b3ef-b1d0706ed669.lovable.app-1778162777740.png" },
      { name: "twitter:image", content: "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/4b46924f-caa5-4891-9ce1-947b090d8720/id-preview-8ea18073--cf527af3-c9f5-472e-b3ef-b1d0706ed669.lovable.app-1778162777740.png" },
    ],
    links: [{ rel: "canonical", href: "https://spayzo.lovable.app/" }],
  }),
});

function Index() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main>
        <Hero />
        <Categories />
        <FeaturedSpaces />
        <HowItWorks />
        <ForMerchants />
        
      </main>
      <SiteFooter />
    </div>
  );
}
